<template>
    <main-page>
        <template v-if="dealerInfo">
            <div class="title text-center mt-4">
                <h1 class="font-weight-normal">
                    <small class="text-gray" v-tr>Welcome to|Bienvenue à</small>
                    {{dealerInfo.company_name}}
                </h1>
                <p v-if="isFromWifi" class="lead"><span v-tr>You now have access to internet|Vous avez maintenant accès à internet</span>
                    <i class="fas fa-wifi ml-2"></i></p>
            </div>

            <div v-if="contentsRecommended.length" class="offers card-container">
                <h5 class="" v-tr>Our selection|Notre sélection</h5>
                <b-row>
                    <card-content v-for="content in contentsRecommended" v-bind:key="content.id" :content="content"></card-content>
                </b-row>
            </div>
            <div v-if="otherContents && otherContents.length > 0" class="offers card-container">
                <h5 class="" v-tr>Our offers!|Nos offres</h5>
                <b-row>
                    <card-content v-for="content in otherContents" v-bind:key="content.id" :content="content"></card-content>
                </b-row>
            </div>

            <div class="mt-3 text-center" v-if="!isFromWifi" >
                <span v-tr>Visit|Visitez</span> <a class="text-info text-underline ml-1" :href="dealerInfo.website" target="_blank">{{dealerInfo.website}}</a>
            </div>
        </template>
        <template v-else-if="loading">
            <e-empty-placeholder :title="'Loading in progress...|Chargement en cours...'|tr" img-src="https://eyeinlivestorage.blob.core.windows.net/public/icons/loading-black.gif">
            </e-empty-placeholder>
        </template>
        <template v-else>
            <e-empty-placeholder :title="'No location selected|Aucun emplacement sélectionné'|tr">
                <b-btn variant="primary" size="sm" to="/"><span v-tr>Back|Retour</span></b-btn>
            </e-empty-placeholder>
        </template>

        <b-modal id="giftModal" :centered="true" size="lg" v-if="birthdayContent" v-model="birthdayModal"
                 :hide-footer="true" title="Surprise!">
            <div v-show="showGift">
                <h3 class="text-center mb-4" v-tr>Happy Birthday!|Joyeux anniversaire!</h3>
                <b-img v-show="!giftOpened" ref="gift" style="width: 250px" @click="giftClicked"
                       :class="giftShaking ? 'shaking' : 'jump'" class="gift"
                       :src="require('../assets/img/gift.png')"></b-img>
                <b-img v-show="giftOpened" class="gift" style="width: 300px"
                       :src="require('../assets/img/gift_opened.png')"></b-img>
            </div>
            <div v-show="!showGift">
                <h6 class="text-center mb-4" v-tr>We've got something for you!|Nous avons quelque chose rien que pour
                    vous!</h6>
                <b-row>
                    <b-col md="6">
                        <b-img fluid :src="getStorageUrl('/login-pages/' + birthdayContent.file_path)" rounded
                               class="offer"></b-img>
                    </b-col>
                    <b-col md="6">
                        <h4 class="mt-3" v-tr>{{birthdayContent.name_for_display||content.name}}</h4>
                        <p v-tr>{{birthdayContent.description}}</p>
                        <div class="text-center">
                            <b-btn @click="contentClicked(birthdayContent)" v-if="birthdayContent.welcome_url" size="sm"
                                   variant="secondary" target="_blank"
                                   :href="birthdayContent.welcome_url">
                                <span v-tr>More Info on my gift|Plus d'informations sur mon cadeau</span>
                                <i class="fas fa-gift ml-1"></i>
                            </b-btn>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </main-page>
</template>

<script>
    import CardContent from "@/views/card-content.vue";
    import canvasConfetti from 'canvas-confetti';
    import EEmptyPlaceholder from "../../vue-components/components/e-empty-placeholder.vue";
    import Network from '../../vue-components/helpers/Network';

    export default {
        name: `dealer-content`,
        components: {CardContent, EEmptyPlaceholder},
        data() {
            return {
                loading: true,
                dealerInfo: null,
                contents: null,
                giftOpened: false,
                giftShaking: false,
                birthdayModal: false,
                showGift: false
            }
        },
        computed: {
            birthday() {
                if (this.user) {
                    return parseInt(this.user.birth_day) === this.$moment().date() && parseInt(this.user.birth_month) === this.$moment().month() + 1
                }
                return false;
            },
            birthdayContent() {
                if (this.user && this.birthday) {
                    return this.contents.find(content => {
                        return content.birthday;
                    });
                }
                return null;
            },
            dealerId() {
                return this.$route.params.dealer;
            },
            contentsRecommended() {
                return this.contents.filter(content => {
                    return this.isContentRecommended(content);
                });
            },
            otherContents() {
                return this.contents.filter(content => {
                    return !this.isContentRecommended(content) && !this.isContentNotRecommended(content) && !content.birthday;
                });
            }
        },
        mounted() {
            if (this.user && this.birthday && this.birthdayContent) {
                this.birthdayModal = true;
                this.giftShaking = true;
                this.showGift = true;
            }
        },
        activated() {
            Network.get(`/wifi-portal/home/${this.dealerId}`)
            .then(resp => {
                this.contents = resp.data.contents;
                this.dealerInfo = resp.data.dealer;
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            });
        },
        methods: {
            contentClicked(content) {
                Network.post(`/wifi-portal/interactions/click`, {
                    session: this.$store.state.session,
                    content_id: content.content_id
                }).catch(() => {

                });
            },
            giftClicked() {
                this.giftOpened = true;
                if (window.outerWidth < 600) {
                    canvasConfetti({
                        particleCount: 500,
                        startVelocity: 30,
                        spread: 360,
                        zIndex: 10000,
                        origin: {
                            x: 0.5,
                            y: 0.4
                        }
                    });
                } else {
                    canvasConfetti({
                        particleCount: 500,
                        startVelocity: 30,
                        spread: 360,
                        zIndex: 10000,
                        origin: {
                            x: (this.$refs[`gift`].x + this.$refs[`gift`].width / 2) / window.innerWidth,
                            y: (this.$refs[`gift`].y + this.$refs[`gift`].height / 2) / window.innerHeight - 0.1
                        }
                    });
                }
                setTimeout(() => {
                    this.showGift = false;
                }, 250);
            },
            isContentRecommended(content) {
                if (!this.user) {
                    return false;
                }

                let tags = content.tags;
                if (isStringEmpty(tags)) {
                    return false;
                }
                tags = tags.split(`&`);

                if (content.birthday && this.birthday) {
                    return true;
                }

                for (let tag of tags) {
                    tag = tag.split(`=`);
                    const name = tag[0];
                    const value = parseInt(tag[1]);

                    if (this.user.use_gender !== false) {
                        if (this.user.gender === `female` && name === `gender_female` && value === 1) {
                            content.recommendation = this.tr(`Because you are a woman|Parce que vous êtes une femme`);
                            return true;
                        } else if (this.user.gender === `male` && name === `gender_male` && value === 1) {
                            content.recommendation = this.tr(`Because you are a man|Parce que vous êtes un homme`);
                            return true;
                        }
                    }

                    if (this.user.use_age !== false && name.startsWith(`age_range_`)) {
                        switch (name.replace(`age_range_`, ``)) {
                            case `13-`:
                                break;
                            case `14-17`:
                                if (this.user.age_range === `< 17` ||
                                    this.user.age_range === `<=17` ||
                                    this.user.age_range === `13-17`) {
                                    content.recommendation = this.tr(`Because you are young|Parce que vous êtes jeune`);
                                    return true;
                                }
                                break;
                            case `18-20`:
                                if (this.user.age_range === `18 - 20`) {
                                    content.recommendation = this.tr(`Because you are a young adult|Parce que vous êtes un jeune adulte`);
                                    return true;
                                }
                                break;
                            default:
                                if (this.user.age_range === `>=21` ||
                                    this.user.age_range === `> 21`) {
                                    content.recommendation = this.tr(`Because you are an adult|Parce que vous êtes un adulte`);
                                    return true;
                                }
                                break;
                        }
                    }
                }
                return false;
            },
            isContentNotRecommended(content) {
                if (!this.user) {
                    return false;
                }

                let tags = content.tags;
                if (isStringEmpty(tags)) {
                    return false;
                }
                tags = tags.split(`&`);

                for (let tag of tags) {
                    tag = tag.split(`=`);
                    const name = tag[0];
                    const value = parseInt(tag[1]);

                    if (this.user.use_gender !== false) {
                        if (this.user.gender === `male` && name === `gender_female` && value === 1) {
                            return true;
                        } else if (this.user.gender === `female` && name === `gender_male` && value === 1) {
                            return true;
                        }
                    }
                }
                return false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-page {
        .title {
            h1 {
                font-size: 25pt;
            }

            .lead {
                font-size: 1.1rem;
                opacity: 0.5;
                font-weight: 500;
            }
        }

        .stores,
        .offers {
            > .row {
                justify-content: center;
            }

            h5 {
                letter-spacing: 1px;
                font-size: 1rem;
                color: #444;
                text-transform: uppercase;
                text-align: center;
                margin-left: 20px;
                margin-bottom: 0;
            }

            .store {
                .card-img-top {
                    object-fit: cover;
                    height: 150px;
                }

                .action {
                    text-align: right;
                }
            }

            .offer {
                max-height: 250px;
                overflow: hidden;

                .card-img-left {
                    height: 100%;
                    min-height: 250px;
                    width: 40%;
                    object-fit: cover;
                    border-top-left-radius: inherit;
                    border-bottom-left-radius: inherit;
                }

                .card-body {
                    padding: 1rem;
                    display: flex;
                    flex-direction: column;

                    h4 {
                        font-size: 1.4rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        flex: 2;
                    }

                    .description {
                        height: 114px;
                        overflow: hidden;
                        font-size: 10pt;
                        flex: 4;
                    }

                    .action {
                        text-align: right;
                    }
                }
            }
        }

        @media(max-width: 576px) {
            .title {
                h1 {
                    font-size: 20pt;
                }

                .lead {
                    font-size: 1rem;
                    opacity: 0.5;
                    font-weight: 500;
                }
            }

            .offers {
                & + .offers {
                    margin-top: 25px;
                }

                h5 {
                    margin-left: 0;
                    font-size: 0.9rem;
                    color: #333;
                    text-align: center;
                }

                .card {
                    margin-bottom: 0;
                }
            }
        }
    }

    #giftModal {
        .gift {
            display: block;
            margin: auto;
        }

        .gift:hover {
            cursor: pointer;
        }

        @keyframes jump {
            0% {
                transform: translate3d(0, -5%, 0) scale3d(1, 1, 1);
            }
            25% {
                transform: translate3d(0, 0%, 0) scale3d(.95, 1.05, 1);
            }
            50% {
                transform: translate3d(0, 5%, 0) scale3d(1.05, .95, 1);
            }
        }

        .jump {
            transform-origin: 50% 50%;
            animation: jump .5s linear alternate infinite;
        }

        @keyframes shake {
            0% {
                transform: translate(1px, 1px) rotate(0deg);
            }
            10% {
                transform: translate(-1px, -2px) rotate(-1deg);
            }
            20% {
                transform: translate(-3px, 0px) rotate(1deg);
            }
            30% {
                transform: translate(3px, 2px) rotate(0deg);
            }
            40% {
                transform: translate(1px, -1px) rotate(1deg);
            }
            50% {
                transform: translate(-1px, 2px) rotate(-1deg);
            }
            60% {
                transform: translate(-3px, 1px) rotate(0deg);
            }
            70% {
                transform: translate(3px, 1px) rotate(-1deg);
            }
            80% {
                transform: translate(-1px, -1px) rotate(1deg);
            }
            90% {
                transform: translate(1px, 2px) rotate(0deg);
            }
            100% {
                transform: translate(1px, -2px) rotate(-1deg);
            }
        }

        .shaking {
            animation: shake 0.5s;
            animation-iteration-count: infinite;
        }
    }
</style>
